export const ACTIVATION_SUPPLIER = 'ACTIVATION_SUPPLIER';
export const ACTIVATION_LOADING = 'ACTIVATION_LOADING';
